module.exports = __webpack_public_path__ + "static/media/button.08369d07.svg";